import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`前言`}</h2>
    <p>{`我并不是一个多细心的人，学生时代常常因为单位写错或者不写而丢分。带入到工作中，即使刻意训练，还是难免粗心大意，多次被自己气哭。问题排查到最后，多是因为`}<strong parentName="p">{`一两行代码`}</strong>{`甚至`}<strong parentName="p">{`一个字母`}</strong>{`导致逻辑不符合预期。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517225512996.png",
        "alt": null
      }}></img></p>
    <p>{`今天就来和大家分享一下我踩过的低级而又深的坑，就当是避个雷吧...`}</p>
    <h2>{`踩过的坑`}</h2>
    <p>{`你看这个饼，它又大又圆。你看这个坑..它又大又深。咳咳，话不多说，直入主题。`}</p>
    <h3>{`请求路径写错`}</h3>
    <p>{`请求路径写错有什么后果大家应该也清楚，我就不多说了。至于写错的场景，其实也很多，比如`}<inlineCode parentName="p">{`/api`}</inlineCode>{` 写成  `}<inlineCode parentName="p">{`//api `}</inlineCode>{` 或者`}<inlineCode parentName="p">{`api`}</inlineCode>{` 。`}</p>
    <p>{`有时候写代码真的是不过脑子，也不过手。排查到最后发现是这种细小错误，长叹一声，好菜。要不是Git提交记录在，都不想承认是自己写的。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517225116333.png",
        "alt": null
      }}></img></p>
    <h3>{`用生产地址测试本地代码`}</h3>
    <p>{`本地改完了，对着生产地址测了许久。`}</p>
    <p>{`嗯？没打印？不能啊？这逻辑必然能进来啊！`}</p>
    <p>{`卧槽？md,这样写总行了吧？`}</p>
    <p>{`嗯？又没反应？？？`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/2021051722540984.png",
        "alt": null
      }}></img></p>
    <p>{`最后发现是环境不一致，真想一拳呼在屏幕...`}</p>
    <p>{`深思良久，只觉得胸中意难平，长虹剑气自丹田凝聚，迸于喉咙，一声怒吼：`}<strong parentName="p">{`键来`}</strong>{`！`}</p>
    <p>{` 此键似有滔天气势，锐不可挡，可搬山，倒海，降妖，镇魔，敕神，摘星，断江，摧城。`}</p>
    <p>{`自今日起，我程序猿一脉皆入`}<strong parentName="p">{`陆地神仙境。`}</strong></p>
    <h3>{`看错项目`}</h3>
    <p>{`当vscode起了多个项目的时候，时常需要来回切换，为什么多个项目？需求多啊... `}</p>
    <p>{`很有可能两个项目存在相似目录结构，相似代码，然后改了半天，愈发迷茫。`}</p>
    <p>{`嗯？热更新失效了？`}</p>
    <p>{`开始怀疑自我，我又变菜了？这不应该啊？`}</p>
    <p>{`任你风吹雨打，页面纹丝不动。大有泰山崩于前而色不变，麋鹿兴于左而目不瞬的架势。`}</p>
    <p>{`欧嚯，心态炸了。。。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517230706962.png",
        "alt": null
      }}></img></p>
    <h3>{`变量名拼错`}</h3>
    <p>{`啥，这都能拼错？`}<strong parentName="p">{`呵，可太能错了呢。`}</strong></p>
    <p>{`错起来千奇百怪，username写成uesrname。`}</p>
    <p>{`乍一看没毛病，再仔细一看，还不如乍一看...`}</p>
    <p><strong parentName="p">{`试问天上剑仙，就没有拿错剑的时候？`}</strong></p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517231155585.png",
        "alt": null
      }}></img></p>
    <h3>{`提交了相似分支`}</h3>
    <p>{`本地开发时候分支可能自己鼓捣了很多，尤其做相同模块的bug修复，命名都差不多，都是xxx-fix。这就导致某些迷糊场景下，你也不知道fix了啥，提交上线可能提交了一个早就不维护的分支，`}<strong parentName="p">{`0 change。`}</strong></p>
    <p>{`en ？？？好家伙，我一脸黑人问号啊？`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517231415833.png?x-oss-process=image/watermark,type_ZmFuZ3poZW5naGVpdGk,shadow_10,text_aHR0cHM6Ly9ibG9nLmNzZG4ubmV0L3FxXzQyODEzNDkx,size_16,color_FFFFFF,t_70",
        "alt": null
      }}></img></p>
    <p>{`温馨提示，命名分支带上日期。`}</p>
    <h3>{`复制粘贴的分支逻辑忘记改过来`}</h3>
    <p>{`我们都喜欢copy,这本身无可厚非，cv一把梭。`}</p>
    <p>{`但是，这也带来很多问题，比如复制过来后忘记对应的改了。`}</p>
    <p>{`对于那种多分支条件，不改就会出现分支二还是走了分支一逻辑的情况，很不利于排查。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517231735362.png",
        "alt": null
      }}></img></p>
    <p>{`温馨提示，copy后要慎重，看看需要改的是否都改了。`}</p>
    <h3>{`数据库存储超限制后会被自动截断`}</h3>
    <p>{`线上线下数据库最主要的差别是性能。为了保证性能，线上的一般不允许你设置过大的字段空间存储，会给定一个限制，超过后就会自动截断。`}</p>
    <p>{`比如你存了一个长json配置字符串，用的时候JSON.parse一波。一把就报错了，因为被截断的已经不是完整的JSON结构。`}</p>
    <p>{`当然这个问题，线下测试数据库未必能暴露出来，允许的空间会很大。`}</p>
    <p>{`上次排查许久才定位到这个问题， 那我还能说什么，菜鸡永不认输！！！`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210517232159169.png",
        "alt": null
      }}></img></p>
    <h2>{`再会`}</h2>
    <p>{`情如风雪无常,`}</p>
    <p>{`却是一动既殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      